export default "__VITE_ASSET__BUTRlin3__"